import {RefObject, useLayoutEffect, useState} from 'react';

const DURATION_MS = 240;
const EASING = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

/**
 * Where the page's own search field (`[data-search-anchor]`, the home page's)
 * is, when it's fully on screen: the box then opens right on top of it, so the
 * field itself seems to become the box.
 */
export const useAnchorRect = () =>
  useState(() => {
    const rect = document.querySelector('[data-search-anchor]')?.getBoundingClientRect();
    return rect && rect.width > 0 && rect.top >= 0 && rect.bottom <= window.innerHeight
      ? rect
      : null;
  })[0];

/**
 * Unrolls the box downward from its header on mount: the header (sitting where
 * the field was) shows first, then the rest is revealed below it. Skipped with
 * reduced motion.
 */
export const useUnroll = (
  ref: RefObject<HTMLElement>,
  {enabled, headerHeight}: {enabled: boolean; headerHeight: number}
) => {
  useLayoutEffect(() => {
    // The card itself, inside the wrapper.
    const box = ref.current?.firstElementChild as HTMLElement | null;
    if (!enabled || !box?.animate) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    box.animate(
      [
        {clipPath: `inset(0 0 calc(100% - ${headerHeight}px) 0 round 12px)`},
        {clipPath: 'inset(0 0 0 0 round 12px)'},
      ],
      {duration: DURATION_MS, easing: EASING}
    );
  }, [ref, enabled, headerHeight]);
};
